import callCmAPI from 'services/helpers/callCmAPI'

export const deleteCustomer = (customerId) =>
  callCmAPI(`/customer/${customerId}`, {
    method: 'delete',
  })
    .then((res) => res.data)
    .catch((err) => err)
